export default __webpack_public_path__ + "static/media/Economics_01_00.e527aef0.png";